import { string, number, oneOfType, bool } from 'prop-types';

const GuestRatingPropTypes = {
  rating: oneOfType([string, number]).isRequired,
  maxRating: oneOfType([string, number]),
  ratingLabel: string,
  reviewCount: oneOfType([string, number]),
  showInline: bool,
};

export default GuestRatingPropTypes;
